__turbopack_context__.v({
  "articlePageTeaser": "TeaserCluster-module-scss-module__klGbja__articlePageTeaser",
  "clusterContainer": "TeaserCluster-module-scss-module__klGbja__clusterContainer",
  "native": "TeaserCluster-module-scss-module__klGbja__native",
  "noCardOutline": "TeaserCluster-module-scss-module__klGbja__noCardOutline",
  "premium": "TeaserCluster-module-scss-module__klGbja__premium",
  "smallCluster": "TeaserCluster-module-scss-module__klGbja__smallCluster",
  "withoutVignette": "TeaserCluster-module-scss-module__klGbja__withoutVignette",
});
